<template>
  <div class="page-main">
    <e-tabs :list="this.$constant.tabListDangan()" isJump />
    <div>家庭成员</div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
